<div
  class="desktop-filters"
  #container
  [class.desktop-filters--map-visible]="isMapVisible$ | async"
>
  <div class="desktop-filters__dropdowns" #dropdownContainer>
    <div class="desktop-filters__dropdown" data-filter="category" #dropdown>
      <app-category-filter-dropdown></app-category-filter-dropdown>
    </div>

    <div class="desktop-filters__dropdown" data-filter="price" #dropdown>
      <app-price-filter-dropdown></app-price-filter-dropdown>
    </div>

    <div
      class="desktop-filters__dropdown"
      data-filter="roomCount"
      *ngIf="displayRoomCount"
      #dropdown
    >
      <app-room-count-filter-dropdown></app-room-count-filter-dropdown>
    </div>

    <div
      class="desktop-filters__dropdown"
      data-filter="livingSpace"
      *ngIf="displayLivingSpace"
      #dropdown
    >
      <app-living-space-filter-dropdown></app-living-space-filter-dropdown>
    </div>

    <div
      class="desktop-filters__dropdown"
      data-filter="usageSpace"
      *ngIf="displayUsageSpace"
      #dropdown
    >
      <app-usage-space-filter-dropdown></app-usage-space-filter-dropdown>
    </div>

    <div
      class="desktop-filters__dropdown"
      data-filter="propertySpace"
      *ngIf="displayPropertySpace"
      #dropdown
    >
      <app-property-space-filter-dropdown></app-property-space-filter-dropdown>
    </div>
  </div>

  <div class="desktop-filters__additional-filters" #additionalFiltersContainer>
    <app-additional-filters-dropdown></app-additional-filters-dropdown>
  </div>
</div>
